import { NgModule } from '@angular/core';
import { CommonInfrastructureModule } from './common/common-infrastructure.module';
import { RouterModule } from '@angular/router';
import { GridModule, BodyModule, SharedModule } from '@progress/kendo-angular-grid';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { ButtonModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { ContextMenuModule, MenuModule, MenusModule } from '@progress/kendo-angular-menu';
import { DialogModule, WindowModule as KendoWindowModule } from '@progress/kendo-angular-dialog';
import { InputsModule, CheckBoxModule } from '@progress/kendo-angular-inputs';
import { PanelBarModule, LayoutModule as KendoLayoutModule } from '@progress/kendo-angular-layout';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { IntlModule } from '@progress/kendo-angular-intl';

import { FormActionModule } from './components/form-action/form-control.module';
import { FormGroupModule } from './components/form-group/form-group.module';
import { FormControlModule } from './components/form-control/form-control.module';
import { WindowModule } from './components/window/window.module';
import { MainPanelModule } from './components/main-panel/main-panel.module';
import { LayoutModule } from './components/layout/layout.module';
import { McbFormsModule } from './common/forms/forms.module';
import { UtilsModule } from './common/utils/utils.module';
import { McbGridModule } from './components/grid/mcb-grid.module';
import { FileUploadModule } from './components/file-upload/file-upload.module';
import { CheckboxModule as McbCheckboxModule } from './components/checkbox/checkbox.module';
import { DatePickerModule } from './components/date-picker/date-picker.module';
import { EnglishInputModule } from './components/english-input/english-input.module';
import { LookupModule } from './components/lookup/lookup.module';
import { MondeyInputModule } from './components/money-input/money-input.module';
import { TimePickerModule } from './components/time-picker/time-picker.module';
import { TreeViewModule as McbTreeeViewModule } from './components/treeview/tree-view.module';
import { GridExtensionModule } from './components/_extensions/grid/grid-extension.module';
import { PersianInputModule } from './components/persian-input/persian-input.module';
import { Lookup2Module } from './components/lookup2/lookup2.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonInfrastructureModule
  ],
  exports: [
    RouterModule,

    // Kendo Components
    GridModule,
    ButtonModule,
    ContextMenuModule,
    DropDownButtonModule,
    DialogModule,
    KendoWindowModule,
    InputsModule,
    PanelBarModule,
    KendoLayoutModule,
    DropDownsModule,
    TreeViewModule,
    ToolBarModule,
    PopupModule,
    CheckBoxModule,
    TooltipModule,
    DateInputsModule,
    IntlModule,
    MenuModule,
    MenusModule,
    BodyModule,
    SharedModule,

    // Mcb Components
    McbCheckboxModule,
    DatePickerModule,
    EnglishInputModule,
    FileUploadModule,

    FormActionModule,
    FormGroupModule,
    FormControlModule,
    McbGridModule,
    LayoutModule,
    LookupModule,
    MainPanelModule,
    MondeyInputModule,
    PersianInputModule,
    TimePickerModule,
    McbTreeeViewModule,
    WindowModule,
    Lookup2Module,

    //
    GridExtensionModule,
    CommonInfrastructureModule,
    McbFormsModule,
    UtilsModule
  ]
})
export class InfrastructureModule {
}
